class StringUtil {
  constructor() {
    this.INVALID_STRING = "Invalid String";
  }

  isValidString(value) {
    return typeof value === "string";
  }

  matchSpecialChars(value) {
    value = value || "";
    return value.match(/[.*+?^${}()|[\]\\]/gi);
  }

  hasSpecialChars(value) {
    let hasSpecialChars = false;
    value = value || "";
    if (Array.isArray(value)) {
      hasSpecialChars = value.some(key => this.matchSpecialChars(key));
    } else {
      hasSpecialChars = this.matchSpecialChars(value);
    }
    return hasSpecialChars;
  }

  escapeEpecialCharacters(value) {
    return value ? value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") : value;
  }

  unescapeEpecialCharacters(value) {
    return value ? value.replace(/\\/g, "") : value;
  }
}

export default new StringUtil();
